<template>
    <div>
        <b-row class="justify-content-center">
            <lottie-player
                src="https://assets8.lottiefiles.com/packages/lf20_jdzh9agx.json"
                background="transparent"
                speed="1.10"
                style="width: 300px; height: 300px;"
                autoplay
                :title="i18nNoRecordsFound"
            />
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        childClass: {
            type: String,
            required: false,
            default: ''
        },
        busy: {
            type: Boolean,
            required: false,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
    },
    computed: {
        i18nNoRecordsFound() {
            return this.getI18n('PAGINATION', 'no_records_found')
        },
    },
}
</script>
